import { Component, Mixins } from 'vue-property-decorator';
import commonEntry from '@/store/modules/commonEntry';
import APP_UTILITIES from '@/utilities/commonFunctions';
import APP_CONST from '@/constants/AppConst';
import applicationStore from '@/store/modules/applications/applicationStore';
import AccountSettings from '@/mixins/accountSettings.mixin';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import { getDecodedToken } from '@/services/common/httpClient';
@Component
export class ApplicationConfirmation extends Mixins(AccountSettings, DeviceWidthCheckerMixin) {

  get userDetail() {
    return commonEntry.userDetail;
  }

  get selectedChildData() {
    return applicationStore.selectedChildData;
  }

  get siteList() {
    return applicationStore.sitesList;
  }

  get applicationData() {
    return applicationStore.applicationDataInfo;
  }

  onClick() {
    this.$gtm && this.$gtm.trackEvent({
      event: null,
      category: 'Application Confirmation',
      action: 'click',
      label: 'Application Save Click Event Activated',
      value: 5000,
      noninteraction: false,
    });
  }

  navigateToSiteSelection() {
    applicationStore.sitesList.forEach(element => {
      if (element.selected) {
        element.selected = false;
      }
    });
    applicationStore.mutateChildrenDropdown({ ...applicationStore.childrenDropdownObj, id: 0, value: 'Select child' });
    this.selectedChildData.id = 0;
    applicationStore.getScholarsByGuardian();
    applicationStore.getSitesByProgramId(this.applicationData.programId);
    const empty_Site_ids: any = [];
    localStorage.setItem('all_selected_sites', JSON.stringify(empty_Site_ids));
    localStorage.setItem('scholar_selected', JSON.stringify(false));
    if (this.siteList.length == 0) {
      this.$router && this.$router.push({ name: 'Select Scholar' });
    }
    else {
      this.$router && this.$router.push({ name: 'Site/Session List' });
    }
  }

  navigateToDashboard() {
    localStorage.removeItem('all_selected_sites');
    this.$router && this.$router.push(APP_CONST.APP_ROUTES.DASHBOARD.path);
  }

  async mounted() {
    if (this.$route !== undefined && this.$gtm !== undefined) {
      this.$gtm.trackView(this.$route.name, this.$route.path);
    }
    const { userId: user_id }: any = await getDecodedToken();
    if (user_id) {
      await commonEntry.fetchUserDetails(parseInt(user_id));
    }
  }
}